module.exports = __webpack_public_path__ + "img/avatar-3.cde2ae68.png";